<template>
  <div class="distributor-mall" :class="languages">
    <distributor-header></distributor-header>
    <Layout class="distributor-container">
      <Sider ref="sider" hide-trigger collapsible :collapsed-width="0" class="distributor-sider"
        :width="250" v-model="isCollapsed" id="distributorSidebarBox">
        <distributor-left></distributor-left>
      </Sider>
      <div class="distributor-mall-box">
        <distributor-breadcrumb></distributor-breadcrumb>
        <div class="distributor-content">
          <!-- 如果当前打开页面的路由中 keepAlive: true （开启了缓存时） -->
          <keep-alive>
            <router-view v-if="$route.meta.keepAlive"></router-view>
          </keep-alive>
          <!-- 如果当前打开页面的路由中 没有 或者为 keepAlive: false （关闭缓存时[默认就是false]） -->
          <router-view v-if="!$route.meta.keepAlive"></router-view>
        </div>
      </div>
    </Layout>
    <distributor-footer :footerLogo="false"></distributor-footer>
    <!--完善账号信息弹窗-->
    <PerfectInformation></PerfectInformation>
    <!--系统公告弹窗-->
    <viewAnnouncementModal :isRegisterTimeAfter="1"></viewAnnouncementModal>
    <!--问卷调研弹窗-->
    <questionnaireModal></questionnaireModal>
    <!--消息通知弹窗-->
    <messageNotificationModal></messageNotificationModal>
    <!--创建备货单包含定制商品的异常提示-->
    <abnormalStockingOfGoodsModal></abnormalStockingOfGoodsModal>
    <!--定制商品设计重复异常提示-->
    <designRepetitionPromptModal></designRepetitionPromptModal>
    <!--右侧固定快捷菜单组件-->
    <fixedRightNav source="distributor"></fixedRightNav>
  </div>
</template>

<script>
import distributorHeader from './header';
import distributorFooter from '../shopping/footer';
import distributorLeft from './left';
import distributorBreadcrumb from '@/components/layout/menu/breadcrumb';
import commonMixin from '@/components/mixin/common_mixin';
import PerfectInformation from '@/components/common/perfectInformation';
import questionnaireModal from "@/components/common/questionnaireModal";
import messageNotificationModal from "@/components/common/messageNotificationModal";
import viewAnnouncementModal from "@/components/common/viewAnnouncementModal.vue";
import {addLangStyle, getSetLanguages} from '@/utils/common';
import abnormalStockingOfGoodsModal from "@/components/common/abnormalStockingOfGoodsModal.vue";
import designRepetitionPromptModal from "@/components/common/designRepetitionPromptModal.vue";
import fixedRightNav from '@/components/common/fixedRightNav';
import {bindAppScrollClosePoppers, unbindAppScrollClosePoppers} from "@/utils/bindAppScrollClosePoppers";

export default {
  mixins: [commonMixin],
  data() {
    return {
      isCollapsed: false,
      keepAliveTalg: false,
      languages: '',
      fullHeight: '',
    };
  },
  mounted() {
    this.$nextTick(() => {
      bindAppScrollClosePoppers({
        selector: '#app',
        useRaf: true
      });
    });
  },
  beforeDestroy() {
    unbindAppScrollClosePoppers();
  },
  async created() {
    await this.$loadProjectTheme();
    this.$webSocket.initWebSocket();
    this.languages = getSetLanguages();
    addLangStyle();
  },
  watch: {
    $route(to, from) {
      let formPath = from.path;
      let toPath = to.path;
      let fromPathArr = ['/newsListDetails'];
      let toPathArr = ['/newsList'];
      if (fromPathArr.includes(formPath) && toPathArr.includes(toPath)) {
        to.meta.keepAlive = true;
      } else {
        to.meta.keepAlive = false;
      }
    }
  },
  components: {
    abnormalStockingOfGoodsModal,
    viewAnnouncementModal,
    PerfectInformation,
    distributorHeader,
    distributorFooter,
    distributorLeft,
    distributorBreadcrumb,
    questionnaireModal,
    messageNotificationModal,
    designRepetitionPromptModal,
    fixedRightNav
  }
};
</script>
